import React from "react";
import styled from "@emotion/styled";
import { stack } from "@ui/style";
import { colors } from "@ui/style/colors";
import { SVGComponent } from "@typings/svg-component";

interface IconCardButtonProps {
	icon: SVGComponent;
	onClick: () => void;
	label: string;
	disabled?: boolean;
	className?: string;
}

export const IconCardButton: React.FC<IconCardButtonProps> = ({ icon: Icon, onClick, label, disabled, className }) => (
	<Container onClick={onClick} disabled={disabled} className={className}>
		<Circle disabled={disabled}>
			<Icon width={24} height={24} color={disabled ? colors.grey50 : colors.primary} />
		</Circle>
		<LabelContainer disabled={disabled} className="p-size-s-bold icon-card-button-label">
			{label}
		</LabelContainer>
	</Container>
);

const Container = styled.div<{ disabled?: boolean }>`
	${stack(16, "flexstart", "center")};
	width: 100%;
	border-radius: 8px;

	${({ disabled }) =>
		disabled
			? `
				border: 1px solid ${colors.grey5};
				background-color: ${colors.grey5};
				pointer-events: none;`
			: `
				border: 1px solid ${colors.primaryBackground};
				background-color: ${colors.primaryBackground};

				cursor: pointer;            
				&:hover,
				&:active {
					border: 1px solid ${colors.primary75};
				}

				&:active {
					background-color: ${colors.primary10};
				}

				&:hover > .icon-card-button-label,
				&:active > .icon-card-button-label {
					color: ${colors.black};
				}`}
`;

const Circle = styled.div<{ disabled?: boolean }>`
	display: grid;
	place-items: center;
	width: 40px;
	height: 40px;
	border-radius: 50%;
	background-color: ${({ disabled }) => (disabled ? colors.grey10 : colors.primary10)};
`;

const LabelContainer = styled.div<{ disabled?: boolean }>`
	text-align: center;
	color: ${({ disabled }) => (disabled ? colors.grey50 : colors.grey)};
`;
